import {KTSVG} from '../../../helpers'
import {AsideMenuItem} from './AsideMenuItem'
import {useAuth} from '../../../../app/modules/auth'

export function AsideMenuMain() {
  const {currentUser} = useAuth()
  const findPermission = (permissionUser) => {
    const hvePermission = currentUser.data?.role.map((role) =>
      role.permissions.some((permission) => permission.id === permissionUser)
    )
    return hvePermission === undefined ? false : hvePermission[0]
  }

  return (
    <>
      <div className='menu-item'>
        <div className='menu-content pb-2'>
          <span className='menu-section text-dark text-uppercase fs-8 ls-1'>Dashboard</span>
        </div>
      </div>
      {findPermission('DASHBOARD') && (
        <AsideMenuItem
          to='/general'
          icon='fas fa-grip-horizontal'
          title={'General'}
        />
      )}
      {findPermission('DASHBOARD') && (
        <AsideMenuItem
          to='/notificationes'
          icon='fas fa-envelope-open'
          title={'Notificationes'}
        />
      )}
      {findPermission('DASHBOARD') && (
        <AsideMenuItem
          to='/campanas'
          icon='fas fa-robot'
          title={'Campañas'}
        />
      )}
      {findPermission('DASHBOARD') && (
        <AsideMenuItem
          to='/cursos'
          icon='fas fa-chalkboard-user'
          title={'Cursos'}
        />
      )}
      {findPermission('DASHBOARD') && (
        <AsideMenuItem
          to='/estudiantes'
          icon='fas fa-users'
          title={'Estudiantes'}
        />
      )}
      {findPermission('DASHBOARD') && (
        <AsideMenuItem
          to='/tracking'
          icon='fas fa-comments'
          title={'Tracking'}
        />
      )}

      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-dark text-uppercase fs-8 ls-1'>SUPER ADMIN</span>
        </div>
      </div>
      {findPermission('SUPERADMIN') && (
       <>
        <AsideMenuItem
          to='/monitoreoAdmin'
          icon='fas fa-gauge'
          title={'Monitoreo'}
        />
        <AsideMenuItem
          to='/trackingAdmin'
          icon='fas fa-comments'
          title={'Tracking'}
        />
       </>
      )}

      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-dark text-uppercase fs-8 ls-1'>REPORTES</span>
        </div>
      </div>
      <AsideMenuItem
        to='/apps/reports-management/reports'
        icon='fas fa-copy'
        title='Reportes'
      />

      {/* <AsideMenuItem
        to='/studients'
        icon='/media/icons/duotune/general/gen025.svg'
        title={intl.formatMessage({id: 'MENU.STUDIENTS'})}
      /> */}
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-dark text-uppercase fs-8 ls-1'>Configuración</span>
        </div>
      </div>
      {findPermission('PERMISSIONS') && (
        <AsideMenuItem
          to='/apps/permission-management/permissions'
          icon='fas fa-shield-halved'
          title='Permisos'
        />
      )}
      {findPermission('USERMANAGEMENT') && (
        <AsideMenuItem
          to='/apps/user-management/users'
          icon='fas fa-user-shield'
          title='Usuarios'
        />
      )}
      {findPermission('ROLEMANAGEMENT') && (
        <AsideMenuItem
          to='/apps/roles-management/roles'
          icon='fas fa-user-lock'
          title='Roles'
        />
      )}
      {findPermission('NOTIFICATION') && (
        <AsideMenuItem
          to='/apps/notification-management/notification'
          icon='fas fa-bell'
          title='Notificaciones'
        />
      )}

      <div className='menu-item'>
        <div className='menu-content'>
          <div className='separator mx-1 my-4'></div>
        </div>
      </div>
      <div className='menu-item'>
        <a target='blank' className='menu-link' href='/#'>
          <span className='menu-icon'>
            <i className='fas fa-code' />
          </span>
          <span className='menu-title'>Changelog 2.0 Musa</span>
        </a>
      </div>
    </>
  )
}
